export const API_ADD_PROGRAM_REQUEST = 'API_ADD_PROGRAM_REQUEST';
export const API_ADD_PROGRAM_SUCCESS = 'API_ADD_PROGRAM_SUCCESS';
export const API_ADD_PROGRAM_FAILURE = 'API_ADD_PROGRAM_FAILURE';
export const RESET_CODE_ERROR = 'RESET_CODE_ERROR';

export const addProgramRequest = () => ({
  type: API_ADD_PROGRAM_REQUEST,
});

export const addProgramSuccess = payload => ({
  type: API_ADD_PROGRAM_SUCCESS,
  payload,
});

export const addProgramFailure = payload => ({
  type: API_ADD_PROGRAM_FAILURE,
  payload,
});

export const resetCodeError = () => ({
  type: RESET_CODE_ERROR,
});

const initialState = {
  isFetched: false,
  fetching: false,
  error: null,
  report: null,
  isProgramCodeValid: false,
};

export function addProgramReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_CODE_ERROR:
      return {
        ...state,
        error: false,
        isProgramCodeValid: false,
      };
    case API_ADD_PROGRAM_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_ADD_PROGRAM_SUCCESS:
      return {
        ...state,
        isFetched: true,
        fetching: false,
        report: action.payload,
        isProgramCodeValid: true,
      };
    case API_ADD_PROGRAM_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.payload,
        isFetched: true,
        report: null,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/addProjectCode.js